import React, { useState } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Calendar } from "react-modern-calendar-datepicker";

const calendar = props => {

  return (
    <Calendar
      value={props.selectedDayRange}
      onChange={props.setSelectedDayRange}
      shouldHighlightWeekends
    />
  );
};

export default calendar;